import { Link } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { mapBgoRoma, mapSalionze } from "../data/mapLinks";
import CorsiCard from "../components/corsi/CorsiCard";
import FAQCategory from "../components/faq/FAQCategory";

function Contatti() {
  const { t } = useTranslation();
  const [openCategory, setOpenCategory] = useState(null);

  const handleCategoryToggle = (category) => {
    setOpenCategory(openCategory === category ? null : category);
  };
  const faqScherma = t("faq.scherma", { returnObjects: true });
  const faqRievocazione = t("faq.rievocazione", { returnObjects: true });

  return (
    <div className="contatti-detail-section">
      <div className="contatti-detail-block">
        <div className="base-header">
          <h2 className="base-title text-center mb-10">{t("contatti.faq")}</h2>
        </div>
        <div>
          <FAQCategory
            title={t("header.scherma")}
            faqList={faqScherma}
            open={openCategory === "scherma"}
            onToggle={() => handleCategoryToggle("scherma")}
          />

          <FAQCategory
            title={t("header.ricostruzione")}
            faqList={faqRievocazione}
            open={openCategory === "rievocazione"}
            onToggle={() => handleCategoryToggle("rievocazione")}
          />
        </div>
      </div>

      <div className="contatti-detail-block">
        <div>
          <div className="base-header">
            <h2 className="base-title text-center mb-10">
              {t("contatti.title")}
            </h2>
          </div>
        </div>
        <div className="contatti-detail-grid">
          <div className="contatti-detail-grid-item">
            <Link
              to="https://www.instagram.com/ordinedellelamescaligere"
              className="footer-social-link"
            >
              <i className="fab fa-instagram fa-8x"></i>
            </Link>
          </div>
          <div className="contatti-detail-grid-item">
            <Link
              to="https://www.facebook.com/ordinedellelamescaligere"
              className="footer-social-link"
            >
              <i className="fab fa-facebook fa-8x"></i>
            </Link>
          </div>
          <div className="contatti-detail-grid-item">
            <Link
              to="mailto:ordinedellelamescaligere@gmail.com"
              className="footer-social-link"
            >
              <i className="fas fa-envelope fa-8x"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="contatti-detail-block">
        <div className="base-header">
          <h2 className="base-title text-center mb-10">
            {t("contatti.where-find")}
          </h2>
        </div>
        <div className="corsi-grid">
          <CorsiCard
            city="Verona"
            place={t("corsi.detail.verona.place")}
            mapLink={mapBgoRoma}
          />
          <CorsiCard
            city="Salionze"
            place={t("corsi.detail.salionze.place")}
            mapLink={mapSalionze}
          />
        </div>
      </div>
    </div>
  );
}

export default Contatti;
